// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const StorageServicePublicAccessSchema = z.enum(['PUBLIC','RESTRICTED','UNKNOWN'] as const);

export type StorageServicePublicAccessType = `${z.infer<typeof StorageServicePublicAccessSchema>}`

export default StorageServicePublicAccessSchema;
